import $ from 'jquery';

// delete confirmation
$("body").popover({
    selector: '[data-toggle="confirm"][data-type="delete"]',
    placement: "auto",
    html: true,
    content: '<span class="popover-message">Are you sure you want to delete this item?</span>'
        + '<div class="d-flex justify-content-between mt-2">'
        + '<a href="#" class="btn btn-sm btn-outline-light popover-close">Cancel</a>'
        + '<a href="#" class="btn btn-sm btn-danger popover-yes">Delete</a>'
        + '</div>'
}).on('inserted.bs.popover', confirmShown);

// delete confirmation
$('[data-toggle="confirm"][data-type="confirm"]').popover({
    placement: "auto",
    html: true,
    content: '<span class="popover-message">Are you sure you want to do it?</span>'
        + '<div class="d-flex justify-content-between mt-2">'
        + '<a href="#" class="btn btn-sm btn-outline-light popover-close">Cancel</a>'
        + '<a href="#" class="btn btn-sm btn-primary popover-yes">Do it!</a>'
        + '</div>'
}).on('inserted.bs.popover', confirmShown);

function confirmShown(eventShown) {
    var $popup = $('#' + $(eventShown.target).attr('aria-describedby'));
    // update settings
    const message = $(eventShown.target).data("message");
    if (message) {
        $popup.find('.popover-message').text(message);
    }
    const yes = $(eventShown.target).data("yes");
    if (yes) {
        $popup.find('.popover-yes').text(yes);
    }
    const no = $(eventShown.target).data("no");
    if (no) {
        $popup.find('.popover-close').text(no);
    }

    $popup.find('.popover-close').click(function (e) {
        e.preventDefault();
        // hide confirmation box
        $popup.popover('hide');

        // trigger event
        eventShown.target.dispatchEvent(new Event("cancelled"));
    });
    $popup.find('.popover-yes').click(function (e) {
        e.preventDefault();

        // hide confirmation box
        $popup.popover('hide');

        // trigger event
        $(eventShown.target).on('hidden.bs.popover', function () {
            eventShown.target.dispatchEvent(new Event("confirmed"));
            $(eventShown.target).unbind('hidden.bs.popover');
        });

        // submit form if possible
        console.log(eventShown.target);
        if (!!$(eventShown.target).data('form')) {
            const formQueryString = $(eventShown.target).data('form');
            console.log(formQueryString);
            $(formQueryString).submit();
        }
        else if ($(eventShown.target).is('[type="submit"]')) {
            // get the closest form and submit
            $(eventShown.target).closest("form").submit();
        }

        // if href then trigger link
        else if ($(eventShown.target).is('[href]')) {
            window.location = $(eventShown.target).attr("href");
        }

        // if modal then show modal
        else if ($(eventShown.target).is('[js-modal]')) {
            $($(eventShown.target).data("target")).modal("show");
        }
    });
}

// close other boxes
$(document).on('click', '[data-toggle="confirm"]', function (e) {
    e.preventDefault();
    $('[data-toggle="confirm"]').not(this).popover('hide'); // all but this
});

// close confirm message on click outside
$(document).on('click', function (e) {
    if (!$(e.target).is('[data-toggle="confirm"]') && $(e.target).closest('[aria-describedby]').length == 0 && $(e.target).closest('.popover').length == 0) {
        $('[data-toggle="confirm"]').popover('hide');
    }
});

export default undefined;